import React, { useState } from 'react';

export const DebugObject = ({ object, forceShow }: { object: any; forceShow?: boolean }) => {
  const [hidden, setHidden] = useState<boolean>(true);
  if (!object) {
    return <div>"null"</div>;
  }
  const keys = Object.keys(JSON.parse(JSON.stringify(object)));
  return (
    <div
      style={
        !forceShow && hidden
          ? {
              opacity: 0.5,
              maxWidth: 150,
              maxHeight: 50,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }
          : {}
      }
      onClick={!forceShow ? () => setHidden(!hidden) : undefined}>
      {keys.length === 1 && typeof object[keys[0]] === 'object' ? (
        <div>
          <h4>Debug: {keys[0]}</h4>
          <DebugObject forceShow={true} object={object[keys[0]]} />
        </div>
      ) : (
        <table>
          <tbody>
            {Object.keys(JSON.parse(JSON.stringify(object)))
              .map((key) => ({ key, value: (object as any)[key] }))
              .map(({ key, value }) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>{JSON.stringify(value)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export const xForAngle = (radius: number, angle: number) =>
  Math.round(radius * Math.cos((angle * Math.PI) / 180));
export const yForAngle = (radius: number, angle: number) =>
  Math.round(radius * Math.sin((angle * Math.PI) / 180));
